import React from 'react'
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
// import Fade from 'react-reveal/Fade';
import ScrollAnimation from 'react-animate-on-scroll';


const useStyles = makeStyles(theme => ({
    container: {
        paddingTop: "50px",
        paddingBottom: "50px",
        paddingLeft: "15%",
        paddingRight: "15%",
        backgroundColor: theme.palette.background.bg1,
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5%",
            paddingRight: "5%",
            paddingTop: "25px",
            paddingBottom: "25px",
        },
    },
    learnButton: {
        ...theme.typography.learnButton,
        fontSize: "0.8rem",
        height: 35,
        padding: 15,
        textDecoration: "none !important",
        color: theme.palette.common.white,
        backgroundColor: theme.palette.common.orange,
        backgroundImage: theme.palette.common.bgGrad1,
        [theme.breakpoints.down("sm")]: {
            marginBottom: "2em"
        },
        clipPath: "polygon(0% 50%, 15% 0%, 100% 0%, 100% 100%, 0% 100%)",
        "&:before": {
            backgroundImage: theme.palette.common.bgGrad2,
            content: "' '",
            display: "block",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: "100%",
            zIndex: "-100",
            transition: "opacity 0.5s",
        },
        "&:hover": {
            backgroundColor: theme.palette.secondary.light,
            "&:before": {
                opacity: 1,
            },
        }
    },
    subtitle: {
        marginBottom: "1em"
    },
    serviceContainer: {
        marginTop: "5em",
        marginBottom: "5em",
        overflowX: "hidden",
    },
}))


export default function FullRow(props) {

    const classes = useStyles();
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
    const content = props.content;
    const dir = props.dir % 2;

    const image = props.image;
    const altImage = props.altImage;

    let imageW = 400;

    if (props.imageW) {
        imageW = props.imageW;
    }

    const subtitleTxt = () => {
        let x = content.subtitle;
        const lines = x.split("\n");
        return (
            <div>
                {lines.map((line, index) => (
                    <Typography variant="subtitle2" className={classes.subtitle} style={{ textAlign: "justify", maxWidth: image ? "650px" : null, lineHeight: 1.5, marginBottom: "0.4em" }}
                        key={index} >
                        {line}
                    </Typography>))}
            </div>
        )
    }


    return (
        <Grid item className={classes.container} style={{ backgroundColor: dir === 0 ? theme.palette.background.bg1 : theme.palette.background.bg2 }}>
            <Grid container direction={dir === 0 ? "row" : "row-reverse"} alignItems="center" justify={matchesSM ? "center" : "space-between"}
                className={classes.serviceContainer} spacing={2}
            >
                <Grid item md={image ? 6 : 12} style={{
                    textAlign: matchesSM ? "center" : undefined
                }}>
                    <Grid item container justify={matchesSM ? "center" : dir === 0 ? "flex-start" : "flex-end"}>
                        <Grid item>
                            {/* <Fade duration={1500} distance={matchesSM ? "0" : null} right={dir === 0 ? true : false} left={dir === 1 ? true : false} > */}
                            <ScrollAnimation animateIn={dir === 0 ? "slideInLeft" : "slideInRight"} animateOnce={true}>
                                <Typography component="h1" variant="h1" paragraph>
                                {content.title}
                            </Typography>
                            <div >
                                {subtitleTxt()}
                            </div>
                            <Button component={Link} href={`/projects/${content.url}`} variant="contained" color="primary">
                                View Projects
                            </Button>
                            {/* </Fade> */}
                            </ScrollAnimation>

                        </Grid>
                    </Grid>
                </Grid>

                {image ? <Grid item container justify={matchesSM ? "center" : dir === 0 ? "flex-end" : "flex-start"} md={6} >
                    <ScrollAnimation animateIn={dir === 0 ? "slideInRight" : "slideInLeft"} animateOnce={true}>
                        <Grid item>
                        {/* <Fade duration={1500} distance={matchesSM ? "0" : null} right={dir === 0 ? false : true} left={dir === 1 ? false : true} > */}
                        <img alt={altImage} src={image} style={{ objectFit: "cover", width: imageW, height: imageW, maxWidth: "100%" }} />
                        {/* </Fade> */}
                    </Grid>
                    </ScrollAnimation>
                </Grid> : null}

            </Grid>
        </Grid >
    )
}
